import React, { useState, useRef } from "react";
import {
  StatusBar,
  Text,
  View,
  StyleSheet,
  TextInput,
  TouchableOpacity,
  Share,
} from "react-native";
import QRCode from "react-native-qrcode-svg";
import { useNavigation } from "@react-navigation/native";
import { useSelector } from "react-redux";
import { selectIdentityList } from "../store/identitySlice";

const QrScreen = () => {
  const [qrvalue, setQrvalue] = useState('E48F5624E050DA28BBE5AB0E82BA49EA2E8182E4');
  const navigation = useNavigation();

  const close = () => {
    navigation.navigate("Home");
  };

  const identityList = useSelector(selectIdentityList);

  return (
    <View style={styles.qr}>
      {identityList.map((item) => (
        <Text style={styles.qrTitle}>{item.nama}</Text>
      ))}

      <View style={styles.qrImage}>
        <QRCode
          value={qrvalue ? qrvalue : "EasyFill"}
          size={250}
          color="black"
        />
      </View>

      <TouchableOpacity onPress={close}>
        <View style={styles.qrButton}>
          <Text style={styles.qrButtonText}>Close</Text>
        </View>
      </TouchableOpacity>
    </View>
  );
};
export default QrScreen;

const styles = StyleSheet.create({
  qr: {
    flex: 1,
    paddingHorizontal: "15vw",
    paddingTop: StatusBar.currentHeight,
  },
  qrTitle: {
    fontSize: 30,
    fontWeight: "500",
    marginTop: "20vh",
    textAlign: "center",
  },
  qrImage: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: 10,
    marginTop: "-15vh",
  },
  qrButton: {
    backgroundColor: "#FF2828",
    paddingVertical: 10,
    alignItems: "center",
    borderRadius: 5,
    marginTop: "-15vh",
  },
  qrButtonText: {
    color: "#F8F8F8",
    fontWeight: "500",
    fontSize: 16,
  },
});
